function LoadingOverlay({ style = {} }) {
  return <div className='loader' style={style}></div>
}

export default LoadingOverlay
